import { axiosJWTInstance } from "../../utils/axiosJWTInstance";
import { Dispatch } from "redux";
import {
  GET_CHANNELS_ATTEMPT,
  GET_CHANNELS_SUCCESS,
  GET_CHANNELS_FAILURE,
} from "../constants";

// getChannels actions
const getChannelsAttempt = () => ({
  type: GET_CHANNELS_ATTEMPT,
});

const getChannelsSuccess = (payload: any) => ({
  type: GET_CHANNELS_SUCCESS,
  payload,
});

const getChannelsFailure = (error: string) => ({
  type: GET_CHANNELS_FAILURE,
  payload: {
    error,
  },
});

export const getChannelsRequest = (data: any, paramsToAdd?:any) => (dispatch: Dispatch) => {
  dispatch(getChannelsAttempt());

  const params2 = {
    entity: "channels",
    ...paramsToAdd
  }

  const searchParams = new URLSearchParams(params2);
  const webUrl = `/Orders?${searchParams.toString()}`;

  return axiosJWTInstance
    .post(webUrl, data, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "content-type": "application/json",
      }
    })
    .then((res) => res.data)
    .then((payload) => {
      dispatch(getChannelsSuccess(payload));
    })
    .catch((error) => {
      dispatch(getChannelsFailure(error.message));
    });
};
